const propertiesMap = {
  'uchwala': 'uchwała',
  'pow metr 2': 'pow. metr. kw.',
  'przewoznik': 'przewoźnik',
  'dzialki_numerdzialki': 'działki - numer działki',
  'dzialki_miejscowosc': 'działki - miejscowość',
  'dzialki_ulica': 'działki - ulica',
  'dzialki_nrbudynku': 'działki - nr budynku',
  'dzialki_nrlokalu': 'działki - nr lokalu',
  'dzialki_kod': 'działki - kod',
  'dzialki_poczta': 'działki - poczta',
  'dzialki_czescdzialki': 'działki - część działki',
  'decyzje_numerwniosku': 'decyzje - numer wniosku',
  'decyzje_datawniosku': 'decyzje - data wniosku',
  'decyzje_znaksprawy': 'decyzje - znak sprawy',
  'decyzje_kategoriainwestycji': 'decyzje - kategoria inwestycji',
  'decyzje_rodzajinwestycji': 'decyzje - rodzaj inwestycji',
  'decyzje_zakresprzedmiotowy': 'decyzje - zakres przedmiotowy',
  'decyzje_powierzchnia': 'decyzje - powierzchnia',
  'decyzje_raportoddzialywania': 'decyzje - raport oddziaływania',
  'decyzje_numerwpisu': 'decyzje - numer wpisu',
  'decyzje_organwydajacy': 'decyzje - organ wydający',
  'decyzje_numerdecyzji': 'decyzje - numer decyzji',
  'decyzje_datawydania': 'decyzje - data wydania',
  'decyzje_datawaznosci': 'decyzje - data ważności',
  'decyzje_statusdecyzji': 'decyzje - status decyzji',
  'decyzje_adnotacjadostatusu': 'decyzje - adnotacja do statusu',
  'decyzje_adnotacjadoostatecznosci': 'decyzje - adnotacja do ostateczności',
  'decyzje_uwagidecyzji': 'decyzje - uwagi decyzji',
  'decyzje_zastrzdotudinf': 'decyzje - zastrzdotudinf',
  'decyzje_numerdzialki': 'decyzje - numer działki',
  'wnioskodawca_imie': 'wnioskodawca - imię',
  'wnioskodawca_nazwisko': 'wnioskodawca - nazwisko',
  'wnioskodawca_nazwa': 'wnioskodawca - nazwa',
  'wnioskodawca_miejscowosc': 'wnioskodawca - miejscowość',
  'wnioskodawca_ulica': 'wnioskodawca - ulica',
  'wnioskodawca_nrbudynku': 'wnioskodawca - nr budynku',
  'wnioskodawca_nrlokalu': 'wnioskodawca - nr lokalu',
  'wnioskodawca_kod': 'wnioskodawca - kod',
  'wnioskodawca_poczta': 'wnioskodawca - poczta',
  'wnioskodawca_telefon': 'wnioskodawca - telefon',
  'wnioskodawca_email': 'wnioskodawca - email',
  'pelnomocnictwo_imie': 'pełnomocnictwo - imie',
  'pelnomocnictwo_nazwisko': 'pełnomocnictwo - nazwisko',
  'pelnomocnictwo_nazwa': 'pełnomocnictwo - nazwa',
  'pelnomocnictwo_miejscowosc': 'pełnomocnictwo - miejscowosc',
  'pelnomocnictwo_ulica': 'pełnomocnictwo - ulica',
  'pelnomocnictwo_nrbudynku': 'pełnomocnictwo - nrbudynku',
  'pelnomocnictwo_nrlokalu': 'pełnomocnictwo - nrlokalu',
  'pelnomocnictwo_kod': 'pełnomocnictwo - kod',
  'pelnomocnictwo_poczta': 'pełnomocnictwo - poczta',
  'pelnomocnictwo_telefon': 'pełnomocnictwo - telefon',
  'pelnomocnictwo_email': 'pełnomocnictwo - email',
  'przechowywanie_nazwainstytucji': 'przechowywanie - nazwa instytucji',
  'przechowywanie_nazwakomorkiorg': 'przechowywanie - nazwa komórki org.',
  'przechowywanie_miejscowosc': 'przechowywanie - miejscowość',
  'przechowywanie_ulica': 'przechowywanie - ulica',
  'przechowywanie_numerbudynku': 'przechowywanie - numer budynku',
  'przechowywanie_numerlokalu': 'przechowywanie - numer lokalu',
  'przechowywanie_numerpokoju': 'przechowywanie - numer pokoju',
  'przechowywanie_kodpocztowy': 'przechowywanie - kod pocztowy',
  'przechowywanie_poczta': 'przechowywanie - poczta',
  'przechowywanie_telefon': 'przechowywanie - telefon',
  'przechowywanie_email': 'przechowywanie - email',
  'podmiot_numerpodmiotu': 'podmiot - numer podmiotu',
  'podmiot_imie': 'podmiot - imię',
  'podmiot_nazwisko': 'podmiot - nazwisko',
  'podmiot_nazwa': 'podmiot - nazwa',
  'podmiot_miejscowosc': 'podmiot - miejscowość',
  'podmiot_ulica': 'podmiot - ulica',
  'podmiot_numerbudynku': 'podmiot - numer budynku',
  'podmiot_numerlokalu': 'podmiot - numer lokalu',
  'podmiot_kodpocztowy': 'podmiot - kod pocztowy',
  'podmiot_poczta': 'podmiot - poczta',
  'podmiot_telefon': 'podmiot - telefon',
  'podmiot_email': 'podmiot - email',
  'dzialki': 'działki', 
  'obreb': 'obręb', 
  'obrebn': 'obręb n', 
  'jednrej': 'jedn. rej.', 
  'datawlad': 'data wiad.', 
  'wartosc': 'wartość', 
  'datawyc': 'data wyc.', 
  'odchylka': 'odchyłka', 
  'powewid': 'pow ewid.', 
  'powgeo': 'pow geo.', 
  'datawer': 'data wer.', 
  'datautw': 'data utw.', 
  'obreb1': 'obręb 1', 
  'powierzchn': 'powierzchnia', 
  'teryt': 'terytorium', 
  'wojewodztw': 'województwo', 
  'data_od': 'data_od', 
  'shape_leng': 'shape_leng', 
  'shape_area': 'shape_area', 
  'nr_obreb_1': 'nr obręb 1',
  'gml_id': 'gml id',
  'lokalnyid': 'lokalny id',
  'przestrzennazw': 'przestrzeń nazw.',
  'wersjaid': 'wersja id',
  'poczatekwersjiobiektu': 'początek wersji obiektu',
  'koniecwersjiobiektu': 'koniec wersji obiektu',
  'przedrostek1czesc': 'przedrostek 1 część',
  'przedrostek2czesc': 'przedrostek 2 część',
  'nazwaczesc': 'nazwa część',
  'nazwaglownaczesc': 'nazwa główna część',
  'idteryt': 'id terytorium',
  'waznyod': 'ważny od',
  'waznydo': 'ważny do',
  'jednostkaadmnistracyjna_1': 'jednostka admnistracyjna',
  'numerporzadkowy': 'numer porządkowy',
  'numerlokalu': 'numer lokalu',
  'jednostkapomocnicza_nazwa': 'jednostka pomocnicza',
  'kodpocztowy': 'kod pocztowy',
  'miejscowosc': 'miejscowość',
  'ulica2': 'ulica 2',
  'elbudreppunktadr': 'elbudrep punkt adr',
  'usytulowaniebudynku': 'usytuowanie budynku',
  'egib': 'egib',
  'status2': 'status 2',
  'jezyk': 'język',
  'dopelniacz': 'dopełniacz',
  'jednostkaadministracyjna1': 'jednostka administracyjna 1',
  'jestczescia': 'jest częścią',
  'nazwageografrp': 'nazwa geograf rp',
  'pelny': 'pełny',
  'pelna': 'pełna',
  'wlasnosc': 'własność',
};
const layersMap = {
  'ad_miejscowosc': 'miejscowość',
  'ad_miejscowosc_p': 'miejscowość p',
  'ad_punktadresowy': 'punkt adresowy',
  'ad_ulica_l': 'ulica l',
  'ad_ulica_p': 'ulica p',
  'dzialki': 'działki',
  'dzialki_ewidencyjne': 'działki ewidencyjne',
  'ekolog': 'ekologia',
  'kierunki_studium': 'kierunki studium',
  'linie_komunikacyjne': 'linie komunikacyjne',
  'mpzp_przeznaczenie_terenow': 'mpzp przeznaczenie terenów',
  'ob_turyst_pkt': 'obiekty turystyczne',
  'ob_turyst_pkt_propozycje': 'obiekty turystyczne - propozycje',
  'turystyczny_noclegi': 'noclegi',
  'turystyczny_noclegi_propozycje': 'noclegi - propozycje',
  'geoportal_ortofoto': 'geoportal ortofoto',
};

const propertiesPattern = new RegExp(Object.keys(propertiesMap).join("|"),"gi");
const layersPattern = new RegExp(Object.keys(layersMap).join("|"),"gi");

// Guide:
// .replace(/_/g, ' ')  // match every _ character and replace with a space
// .replace(propertiesPattern, matched => propertiesMap[matched]) // if matched, changes key to value from object propertiesMap
// .replace(/[^%]*/i)[0], matched => matched[0].toUpperCase() + matched.slice(1)) // match zero-or-more character, which is not a % - and to upper case

export {
  propertiesMap,
  propertiesPattern,
  layersMap,
  layersPattern,
};



// WEBPACK FOOTER //
// src/data/propertiesMap.js